import { render, staticRenderFns } from "./learnProject.vue?vue&type=template&id=283a6bb2&scoped=true"
import script from "./learnProject.vue?vue&type=script&lang=js"
export * from "./learnProject.vue?vue&type=script&lang=js"
import style0 from "./learnProject.vue?vue&type=style&index=0&id=283a6bb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283a6bb2",
  null
  
)

export default component.exports